import styled from 'styled-components'
import { Button } from 'antd'
import colors from 'globals/colors'

interface ButtonProps {
  alternativestyle?: string,
  color: string,
}

export const SButton = styled(Button)<ButtonProps>`
  &.ant-btn {
    height: 40px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;

    ${(props) => props.alternativestyle !== 'true' && `
      &:not([disabled]) {
        background: ${props.color};
        border-color: ${props.color};
      }
    `};
    
    &.ant-btn-lg {
      padding: 11.4px 25px;
    }

    &[disabled] {
      background: ${colors.lightGrey};
      border-color: ${colors.lightGrey};
    }

    ${(props) => props.alternativestyle === 'true' && `
      background: ${colors.white};
      color: ${props.color};
      border: 1px solid ${props.color};
      
      &:hover, &:focus {
        background: ${colors.white};
        border-color: ${props.color};
        color: ${props.color};
        opacity: 0.5;
      }
      
      &[disabled] {
        opacity: 0.5;
      }
    `};
    
    &.ant-btn-sm {
      height: 32px;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      padding: 5px 15px;
    }
    
    &.ant-btn-lg {
      height: 50px;
    }

    &:hover {
      background: ${colors.darkBlue};
    }
  }
`
